import {StyledAlertMessage, StyledAlertMessageIcon} from '@/components/commons/alert-message/style'
import {PaletteKey, TextProps} from '@/components/ui/text/Text'
import {ReactNode} from 'react'

type AlertMessageProps = {
    message: string
    icon: ReactNode
    iconSize?: number
} & Exclude<TextProps<PaletteKey>, 'size'>

export const AlertMessage = ({message, icon, iconSize, ...rest}: AlertMessageProps) => {
    return (
        <StyledAlertMessage {...rest}>
            <StyledAlertMessageIcon $size={iconSize}>{icon}</StyledAlertMessageIcon>
            {message}
        </StyledAlertMessage>
    )
}
